import { Link, useNavigate } from "react-router-dom"
import Pagination from "../../Components/Pagination"
import SearchField from "../../Components/Forms/SearchField";

export default function NeutralTable({data, color}){

    const navigate = useNavigate();
    

    return (
        <div className="px-4 md:px-8">    
            <div className={`mt-12 overflow-x-auto border rounded-lg shadow-sm border-${color}`}>
                <table className="w-full text-sm text-left table-auto">
                    <thead className={`font-medium text-gray-600 border-b bg-${color}`}>
                        <tr>
                            <th className="px-6 py-3 text-gray-100">Id</th>
                            <th className="px-6 py-3 text-gray-100">Clients</th>
                            <th className="px-6 py-3 text-gray-100">Date</th>
                            <th className="px-6 py-3 text-gray-100">status</th>
                            <th className="px-6 py-3 text-gray-100">Annonce</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 divide-y">
                        {
                            data.map((item, idx) => (
                                
                                    <tr key={idx} className="w-full text-left transition rounded cursor-pointer hover:bg-gray-100 duration-900"
                                        onClick={()=>navigate(`/reservation/details/${item.id}`)}
                                    >
                                        
                                            <td className="flex items-center px-6 py-3 gap-x-3 whitespace-nowrap">
                                                <div>
                                                    <span className="block text-sm font-medium text-gray-700">{item.id}</span>
                                                </div>
                                            </td>
                                            
                                            <td className="px-6 py-4 whitespace-nowrap">{item.client.firstname}</td>
                                            
                                            <td className="px-6 py-4 whitespace-nowrap">{new Date(item.createdAt).toLocaleDateString()}</td>
                                            {item.status === 2 && <span className={`px-3 py-2 rounded-full font-semibold text-xs text-green-600 bg-green-50`}>
                                            {'Confirmée'}
                                            </span>}

                                            {item.status === 0 && <span className={`px-3 py-2 rounded-full font-semibold text-xs text-gray-600 bg-gray-50`}>
                                            {'En attente'}
                                            </span>}

                                            {item.status === 1 && <span className={`px-3 py-2 rounded-full font-semibold text-xs text-purple-600 bg-purple-50`}>
                                            {'Approuvée'}
                                            </span>}

                                            {item.status === -1 && <span className={`px-3 py-2 rounded-full font-semibold text-xs text-red-600 bg-red-50`}>
                                            {'Annulée'}
                                            </span>}

                                            {item.status === -2 && <span className={`px-3 py-2 rounded-full font-semibold text-xs text-red-600 bg-red-50`}>
                                            {'Refusée'}
                                            </span>}

                                            {item.status === 3 && <span className={`px-3 py-2 rounded-full font-semibold text-xs text-yellow-600 bg-red-50`}>
                                            {'Terminée'}
                                            </span>}
                                            <td className="px-6 py-4 whitespace-nowrap">{item.annonce.title}</td>


                                            
                                    </tr>
                                
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}